import ISO from "../assets/resources/iso27001.pdf";
import Cyber from "../assets/resources/cyber-essentials.pdf";

export const resourcesTranslations = {
  en: {
    title: "Resources",
    subTitle: "Find legal information and resources for our products and services",
    cards: {
      general: {
        header: "General",
        content: [
          { title: "Privacy Statement & Terms", path: "/privacypolicy" },
          { title: "Cookie Policy", path: "/cookiepolicy" }
        ]
      },
      security: {
        header: "Security",
        content: [
          { title: "Cyber Essentials Plus Certificate", path: "/cyber" },
          { title: "ISO-27001 Certificate", path: "/iso" }
        ]
      },
      environment: {
        header: "Environment, Social and Governance",
        content: [
          { title: "Carbon Reduction Plan 2023 - 2024", path: "/carbon-reduction-23-24" }
        ]
      }
    }
  },
  fr: {
    title: "Ressources",
    subTitle: "Trouvez des informations légales et des ressources pour nos produits et services",
    cards: {
      general: {
        header: "Général",
        content: [
          { title: "Déclaration de confidentialité & Conditions", path: "/privacypolicy" },
          { title: "Politique de cookies", path: "/cookiepolicy" }
        ]
      },
      security: {
        header: "Sécurité",
        content: [
          { title: "Certificat Cyber Essentials Plus", path: "/cyber" },
          { title: "Certificat ISO-27001", path: "/iso" }
        ]
      },
      environment: {
        header: "Environnement, Social et Gouvernance",
        content: [
          { title: "Plan de réduction des émissions de carbone 2023 - 2024", path: "/carbon-reduction-23-24" }
        ]
      }
    }
  },
  de: {
    title: "Ressourcen",
    subTitle: "Finden Sie rechtliche Informationen und Ressourcen für unsere Produkte und Dienstleistungen",
    cards: {
      general: {
        header: "Allgemein",
        content: [
          { title: "Datenschutzerklärung & Bedingungen", path: "/privacypolicy" },
          { title: "Cookie-Richtlinie", path: "/cookiepolicy" }
        ]
      },
      security: {
        header: "Sicherheit",
        content: [
          { title: "Cyber Essentials Plus Zertifikat", path: "/cyber" },
          { title: "ISO-27001 Zertifikat", path: "/iso" }
        ]
      },
      environment: {
        header: "Umwelt, Soziales und Governance",
        content: [
          { title: "CO2-Reduktionsplan 2023 - 2024", path: "/carbon-reduction-23-24" }
        ]
      }
    }
  },
  es: {
    title: "Recursos",
    subTitle: "Encuentre información legal y recursos para nuestros productos y servicios",
    cards: {
      general: {
        header: "General",
        content: [
          { title: "Declaración de privacidad y términos", path: "/privacypolicy" },
          { title: "Política de cookies", path: "/cookiepolicy" }
        ]
      },
      security: {
        header: "Seguridad",
        content: [
          { title: "Certificado Cyber Essentials Plus", path: "/cyber" },
          { title: "Certificado ISO-27001", path: "/iso" }
        ]
      },
      environment: {
        header: "Medio ambiente, Social y Gobernanza",
        content: [
          { title: "Plan de Reducción de Carbono 2023 - 2024", path: "/carbon-reduction-23-24" }
        ]
      }
    }
  }
};